import { render, staticRenderFns } from "./PerfPerArticle.vue?vue&type=template&id=1e4ace88&scoped=true&"
import script from "./PerfPerArticle.vue?vue&type=script&lang=js&"
export * from "./PerfPerArticle.vue?vue&type=script&lang=js&"
import style0 from "./PerfPerArticle.vue?vue&type=style&index=0&id=1e4ace88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ace88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDataTable,VRow,VTextField})
